
  import { Vue, Component, Prop } from "vue-property-decorator";
  import CardBodyItem from "@/components/card/CardBodyItem.vue";
  import RouteParams from "@/entities/RouteParams";

  @Component({
    components: {
      CardBodyItem,
    },
  })
  export default class CardBodyItemLink extends Vue {
    @Prop({ type: String, required: true }) readonly label!: string;
    @Prop({ type: [String, Number], required: true }) readonly value!: string | number;
    @Prop({ type: Object, required: true }) readonly routeLink!: RouteParams<any>;

  }
